import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent),
    data: {
      title: 'Iniciar Sessión',
    },
  },
  {
    path: 'forgot',
    loadComponent: () =>
      import('./auth/forgot/forgot.component').then((m) => m.ForgotComponent),
    data: {
      title: 'Olvidó la Contraseña?',
    },
  },
  {
    path: 'maps',
    loadComponent: () =>
      import('./views/locations/locations.component').then(
        (m) => m.LocationsComponent
      ),
    data: {
      title: 'Ubicaciones Maps',
    },
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./views/home/home.component').then((m) => m.HomeComponent),
    data: {
      title: 'Inicio',
    },
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./views/profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
    data: {
      title: 'Perfil de Usuario',
    },
  },
  {
    path: 'social',
    loadComponent: () =>
      import('./views/social/social.component').then((m) => m.SocialComponent),
    data: {
      title: 'Redes Sociales',
    },
  },
  { path: '**', redirectTo: 'login' },
];
